<template>
  <v-app>
    <!-- <login/> -->
  <!-- <div class="Dashboard"> -->
      <!-- <introduction /> -->
    
      <div class="center-text" align="center">
        
      <table>
        <v-card-title class="d-flex justify-center">
            <!-- <h1 class="font-weight-bold text-h4"> -->
                <div class="studies-header">CPTAC Melanoma studies:</div>
                
            <!-- </h1> -->
            
            </v-card-title>
        <thead>
            
          <tr>
            <!-- <th>Photo</th>
            <th>Name</th> -->
			<!-- <th>Role</th> -->
            <!-- <th>Email</twh> -->
          </tr>
        </thead>
        <tbody>
          <tr class="center-photos" align="center">
             <td v-for="(portal, index) in portals" :key="index">
               <v-card
               
                  class="ma-4"
                  max-width="350"
                  @click="$router.push(portal.router_path)"
                >
                <v-card-text >
                   <div class="short-title"> {{ portal.tabTitle }} </div>
                </v-card-text>
                  <v-img
                    :src="portal.graphicaAbstract"
                    class="align-end text-white"
                    max-height="350"
                    cover
                    contain
                  >
                  </v-img>
                <v-card-text>
                  <div class="citation-smaller">  {{ portal.citation }} </div>
                </v-card-text>
                <v-card-text v-if="portal.citation2">
                  <div class="citation-smaller">  {{ portal.citation2 }} </div>
                </v-card-text>
                </v-card>
             </td>
             <br>
          </tr>
        </tbody>
      </table>
      </div>
  </v-app>
</template>

<script>
// import Introduction from './components/Introduction.vue';


export default {
  name: 'App',

  components: {

    // Introduction,

  },
  created(){
    // this.$store.dispatch('videos/loadAll');
    // this.$store.dispatch('users/loadCurrent');
    // this.$store.dispatch('tags/loadAll');
  },
  computed: {
    cohortsInRouter() {
      return this.$store.state.router_to_headerInfo
    },
    portals() {
        const portalDict = [
            {
                shortTitle: 'PTRC',
                tabTitle: 'ICI subtype',
                router_path: '/ptrc',
                citation: this.cohortsInRouter['/ptrc'][1],
                graphicaAbstract: "https://cdn.vuetifyjs.com/images/parallax/material.jpg"
                // website: 'https://ptrc-portal.cptac-data-view.org/',
                // website: 'https://ccrcc-conf.cptac-data-view.org/',
                // graphicaAbstract: require('./assets/portal_img/ccrcc-conf.jpg'),
                // citation: 'Li et. al. Histopathologic and proteogenomic heterogeneity reveals features of clear cell renal cell carcinoma aggressiveness, Cancer Cell 2023, PMID: 36563681',
            },
            {
                shortTitle: 'PCC',
                tabTitle: 'Multi-Omics atlas',
                router_path: '/pcc',
                citation: this.cohortsInRouter['/pcc'][1],
                graphicaAbstract: "https://cdn.vuetifyjs.com/images/parallax/material2.jpg"
                // website: 'https://ptrc-ddr.cptac-data-view.org/',
                // graphicaAbstract: require('./assets/portal_img/ddr.png'),
                // citation: 'Huang et. al. A highly annotated database of genes associated with platinum resistance in cancer. Oncogene. 2021 Nov;40(46):6395-6405. doi: 10.1038/s41388-021-02055-2. Epub 2021 Oct 13. PMID: 34645978; PMCID: PMC8602037.',
            },
        ]
        return portalDict
    }
    // view() { return this.$store.state.view },
    // showBoxplot() { return this.view === 'Boxplot' ? "" : "display: none;" },
    // // showDemo() { return this.view === 'Demo' ? "" : "display: none;" },
    // showHeatmap() { return this.view === 'Heatmap' ? "" : "display: none;" },
    // // showIprofun() { return this.view === 'Iprofun' ? "" : "display: none;" },
    // showSampleDashboard() { return this.view === 'Sample dashboard' ? "" : "display: none;" },
    // showScatterplot() { return this.view === 'Scatterplot' ? "" : "display: none;" },
    // showQualityControl() { return this.view === 'Quality control' ? "" : "display: none;" },
    // showHistologyViewer() { return this.view === 'Histology viewer' ? "" : "display: none;" },
    // ...mapState({
    //   currentUser: state => this.$store.state.users.currentUser, 
    //   // snackbars: state => state.snackbar.snackbars
    // })
  },
  data: () => ({}),

  mounted() { 
      // this.$store.dispatch('getTracks', 
      //     { 
      //       view: 'Heatmap', 
      //       genes: ['LXN', 'ARVCF'],
      //       combine_bool: true,
      //     }
      //   )
  }
};
</script>

<style scoped>

.center-text {
  font-size: min(2vm, 30px);
  /* position: center; */
  /* text-align: center; */
  /* align-items: center; */
  padding-left: 5%; 
  padding-right: 5%;
  display: block;
}

.center-one-each-row {
  margin-left: auto;
  margin-right: auto;

}

.center-photos {
  /* margin-left: auto;
  margin-right: auto; */
  /* padding: 0; */
  /* padding-left: 11%; 
  padding-right: 11%; */
    /* margin-left: auto;
    margin-right: auto;
    list-style-type: none; */
    /* display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex; */
    display: flex;
    justify-content: center;
    /* -webkit-flex-flow: row wrap; */
    /* flex-direction: row wrap; */
    flex-wrap: wrap;
    /* justify-content: space-evenly; */
}


.citation {
  color: #219EBC;
  /* font-size: max(0.9vw, 20px); */
  font-size: max(0.9vw, 20px);
  text-align: left;
}

.citation-smaller{
  color: #219EBC;
  /* font-size: max(0.9vw, 20px); */
  font-size: max(0.7vw, 16px);
  text-align: left;
}

.short-title {
  color: #219EBC;
  font-weight: bold;
  /* font-size: max(0.9vw, 20px); */
  font-size: max(1.1vw, 23px);
}

.centered-container {
  /* font-family: arial;
  font-size: 24px;
  margin: 25px;
  width: 350px;
  height: 400px;
  outline: dashed 1px black; */
  /* Center child horizontally*/
  display: flex;
  justify-content: center;
}

.overlay {
  position: absolute;
  /* top: 50%; */
  /* left: 50%; */
  /* -webkit-transform: translate(-50%, -50%); */
  /* transform: translate(20%, 0);
  
  opacity: 0; */
  margin-left: auto;
  margin-right: auto;
  transition: 0.5s ease;
  background-color: #1F497E;
  /* background-color: #008cba; */
}

.content {
  display: flex;
  justify-content: center;

  /* justify-content: space-around; */
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
}

.center-photos>td{
  flex: 1 0 13vw;
}

.studies-header {
  font-size: 1.4em;
  /* margin-bottom: 10px; */
  color: #219EBC;
  font-weight: 600;
}
</style>